import React from "react";
import { Container } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { trackEvent } from "../../utils/analytics";
import Reveal from "../Reveal";
import { PageConversionWrapper, PrimaryCta, GhostCta } from "./styles";

const PageConversion = () => {
	const navigate = useNavigate();

	const handleNavigateInvitations = () => {
		navigate("/invitation-templates");
	};

	return (
		<PageConversionWrapper>
			<Container>
				<Reveal>
					<div className={"cta-panel"}>
						<h2>Create your digital invitation in minutes</h2>
						<p>
							Browse designs, customize every detail, manage RSVPs, and share your invitation and album with ease.
						</p>
						<div className={"cta-actions"}>
							<PrimaryCta
								type={"button"}
								onClick={() => {
									trackEvent("view_invitations", {
										scope: "Invitations",
										description: "View Invitations"
									});
									handleNavigateInvitations();
								}}
							>
								View Invitations
								<ArrowForward />
							</PrimaryCta>
							<GhostCta as={Link} to={"/pricing"}>
								See pricing
							</GhostCta>
						</div>
					</div>
				</Reveal>
			</Container>
		</PageConversionWrapper>
	);
};

export default PageConversion;
